import corporateRequest from 'utils/corporateRequest'

export const setDrivesList = data => {
  return {
    type: 'SET_DRIVES_LIST',
    data,
  }
}
export const setDrivesDateCalender = data => {
  return {
    type: 'SET_DRIVES_DATE_CALENDER',
    data,
  }
}

export const getDrivesList =
  ({ occurrence, driveModeList, date, page, setLoading }) =>
  async (dispatch, getState) => {
    setLoading(true)
    const state1 = getState()
    let occurrenceKey = occurrence ? `&occurrence=${occurrence}` : ''
    let driveModeKey =
      driveModeList?.length > 0
        ? `&driveMode=${driveModeList
            .toString()
            .toUpperCase()
            .replaceAll(' ', '_')}`
        : ''
    let dateKey = date ? `&date=${date}` : ''
    let pageKey = `&currentPage=${page}` 
    if(state1?.studentData?.studentDetails?.isExpCandidate)
    {
      try {
        const res = await corporateRequest.get(
          `corporates/drive/${state1?.auth?.studentId}/list?pageLimit=10${pageKey}${dateKey}${occurrenceKey}${driveModeKey}&sort=createdAt&order=desc`
        )
        dispatch(setDrivesList(res?.data?.data))
        setLoading(false)
      } catch (error) {
        console.log('Error in Getting drive list', error)
      }
      try {
        const res = await corporateRequest.get(
          `corporates/drive/${state1?.auth?.studentId}/list?pageLimit=10${pageKey}${occurrenceKey}${driveModeKey}&sort=createdAt&order=desc`
        )
        dispatch(setDrivesDateCalender(res?.data?.data))
        setLoading(false)
      } catch (error) {
        console.log('Error in Getting drive list', error)
      }
    }
    else
    {
    try {
      const res = await corporateRequest.get(
        `corporates/drive/${state1?.studentData?.studentDetails.instituteCampusId}/${state1?.auth?.studentId}/list?pageLimit=10${pageKey}${dateKey}${occurrenceKey}${driveModeKey}`
      )
      dispatch(setDrivesList(res?.data?.data))
      setLoading(false)
    } catch (error) {
      console.log('Error in Getting drive list', error)
    }
    try {
      const res = await corporateRequest.get(
        `corporates/drive/${state1?.studentData?.studentDetails.instituteCampusId}/${state1?.auth?.studentId}/list?pageLimit=10${pageKey}${occurrenceKey}${driveModeKey}`
      )
      dispatch(setDrivesDateCalender(res?.data?.data))
      setLoading(false)
    } catch (error) {
      console.log('Error in Getting drive list', error)
    }
  }
  }
